/* eslint-disable */
import { connect } from 'react-redux'
import React from 'react';
import { Button, ControlLabel, Form, FormGroup, FormControl } from 'react-bootstrap';

import OzComponent from '../../lib/OzComponent';
import { ss, adminBecome, setToken, mapDispatch } from '../../utils/util';
import Wrapper from '../Wrapper';

import {
  makeClaimLink,
} from '../../actions';


class Admin extends OzComponent {
  state = {};

  become(e) {
    e.preventDefault();
    adminBecome(this.state.email)
      .then(resp => {
        if (!resp.token) {
          alert("It didn't work...");
          return;
        }
        console.log('became:', resp);
        setToken(resp.token);
        alert(`Success! You have become ${this.state.email}.\n\nRemember to log out when you are done.`);
        window.location.href = '/';
      });
  }

  claimLink(e) {
    e.preventDefault();
    let values = {
      email: this.state.claimEmail,
      company: this.state.claimCompany,
    };
    console.log('values', values);
    this.props.makeClaimLink(values)
      .then(resp => {
        console.log('make claim resp', resp);
        if(resp.error) {
          alert("error! couldn't claim!");
          return;
        }
        this.setState({ claimUrl: resp.url });
      });
  }

  render() {
    return (
      <Wrapper title="Admin">
        <div className="Admin">
          <h2>Become a user</h2>
          <Form onSubmit={(e) => this.become(e)}>
            <FormGroup>
              <ControlLabel>The user's email:</ControlLabel>
              <FormControl
                type="text"
                value={this.state.email}
                onChange={ss(this, 'email')}
                placeholder="user@email.com"
              />
            </FormGroup>
            <Button type="submit">Become the user!</Button>
          </Form>

          <h2>Claim link</h2>
          <Form onSubmit={(e) => this.claimLink(e)}>
            <FormGroup>
              <ControlLabel>The user's email:</ControlLabel>
              <FormControl
                type="text"
                value={this.state.claimEmail || ''}
                onChange={ss(this, 'claimEmail')}
                placeholder="user@email.com"
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Company name (exact spelling):</ControlLabel>
              <FormControl
                type="text"
                value={this.state.claimCompany || ''}
                onChange={ss(this, 'claimCompany')}
                placeholder="Some Escape Company"
              />
            </FormGroup>
            <Button type="submit">Make Claim Link</Button>
          </Form>

          {this.state.claimUrl}
        </div>
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    isLoggedIn: state.isLoggedIn,
    orderSuppliers: state.orderSuppliers,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    makeClaimLink,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Admin);



/** WEBPACK FOOTER **
 ** ./src/components/admin/Admin.js
 **/